package pt.at.oss.kotlin.manual.storage.common

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * CurrVatId Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class VatId(
    var scheme: String? = null,
    var issuingCountry: String? = null,
    var vatIdNum: String = "",
    var taxRefNum: String = ""
) : BaseRecord()
